import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiDelete } from '@/lib/http/client';
import {
  orgSnowflakeConnectionUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';

export function useRevokeSnowflakeConnection(orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => apiDelete<unknown>(orgSnowflakeConnectionUrl(orgId)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgSnowflakeConnection(orgId),
      });
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgSnowflakeRequests(orgId),
      });
    },
  });
}
